export default {
  selection: false,
  searchFields: [
    // 搜索组件的配置项
    {
      name: "出运编码",
      value: "ship_no",
      type: "input",
      isFixed: true,
      span: 4,
    },
    {
      name: "物流单号",
      value: "shipping_waybill_no",
      type: "input",
      isFixed: true,
      span: 4,
    },
  ],
  columns: [
    // 表格列的配置
    {
      label: "发货日期",
      prop: "shipping_time",
    },
    {
      label: "相关订单",
      prop: "ord_no",
    },
    {
      label: "出运编码",
      prop: "ship_no",
      type: "shipNo",
    },
    {
      label: "发票编码",
      prop: "inv_no",
    },
    {
      label: "承运货代",
      prop: "spr_name_ch",
    },
    {
      label: "发货渠道",
      prop: "shipping_name_ch",
    },
    {
      label: "物流单号",
      prop: "shipping_waybill_no",
      type: "waybillNo",
    },
    {
      label: "收费重量",
      prop: "pkg_weight",
    },
    {
      label: "打包费",
      prop: "packing_fee_total",
    },
    {
      label: "出运费",
      prop: "shipping_cost",
    },
    {
      label: "总运费",
      prop: "shipping_total",
    },
    {
      label: "生成日期",
      prop: "create_time",
    },
    {
      label: "预期发货",
      prop: "expected_time",
    },
    {
      label: "操作",
      type: "operate_btn",
      prop: "",
      width: "200px",
    },
  ],
  forms: [
    {
      label: "出运单号",
      prop: "ship_no",
      type: "input",
      disabled: true,
    },
    {
      label: "签收时间",
      prop: "receipt_time",
      type: "time",
      rule: [{ required: true, message: "请录入签收日期", trigger: "blur" }],
    },
  ],
};
